import ThemeManager from "project-config/services/theme-manager";
ThemeManager.init();
const newTheme = ThemeManager.newTheme;

export enum AnalysisTaskStatus {
  /** 分析完成 */
  done,
  /** 分析完成(有警告) */
  warning = 5,
  /** 分析完成(有错误) */
  error = 10,
  /** 分析失败 */
  failed = 15,
  /** 分析中 */
  analyzing = 20,
  /** 等待分析 */
  waiting = 25,
  /** 提交渲染失败 */
  submit_failed = 30,
  /** 已自动提交 */
  auto_submit = 35,
  /** 已提交 */
  submitted = 40,
  /** 放弃 */
  abort = 45,
  /** 分析超时 */
  timeout = 48,
}

export enum AnalysisActionName {
  "submit" = 1,
  "restart" = 2,
  "abandon" = 3,
  "delete" = 4,
}

export const AllAnalysisActionName = [
  AnalysisActionName.submit,
  AnalysisActionName.restart,
  AnalysisActionName.abandon,
  AnalysisActionName.delete,
];

export const AnalysisActionNameMap = new Map<
  AnalysisActionName,
  keyof typeof AnalysisActionName
>([
  [AnalysisActionName.submit, "submit"],
  [AnalysisActionName.restart, "restart"],
  [AnalysisActionName.abandon, "abandon"],
  [AnalysisActionName.delete, "delete"],
]);

export const AnalysisDisableAction = [
  AnalysisActionName.restart,
  AnalysisActionName.delete,
];
export const AnalysisStatusActionMap = new Map<
  AnalysisTaskStatus,
  AnalysisActionName[]
>([
  [AnalysisTaskStatus.done, AllAnalysisActionName],
  [AnalysisTaskStatus.warning, AllAnalysisActionName],
  [
    AnalysisTaskStatus.error,
    [
      AnalysisActionName.restart,
      AnalysisActionName.abandon,
      AnalysisActionName.delete,
    ],
  ],
  [
    AnalysisTaskStatus.failed,
    [
      AnalysisActionName.restart,
      AnalysisActionName.abandon,
      AnalysisActionName.delete,
    ],
  ],
  [AnalysisTaskStatus.analyzing, [AnalysisActionName.abandon]],
  [AnalysisTaskStatus.waiting, [AnalysisActionName.abandon]],
  [
    AnalysisTaskStatus.submit_failed,
    [AnalysisActionName.submit, AnalysisActionName.delete],
  ],
  [
    AnalysisTaskStatus.auto_submit,
    [AnalysisActionName.restart, AnalysisActionName.delete],
  ],
  [
    AnalysisTaskStatus.submitted,
    [AnalysisActionName.restart, AnalysisActionName.delete],
  ],
  [
    AnalysisTaskStatus.abort,
    [AnalysisActionName.restart, AnalysisActionName.delete],
  ],
  [
    AnalysisTaskStatus.timeout,
    [
      AnalysisActionName.restart,
      AnalysisActionName.abandon,
      AnalysisActionName.delete,
    ],
  ],
]);

export const AnalysisStatusFilterList = Object.values(
  AnalysisTaskStatus
).filter((value) => typeof value !== "string");

export const AllAnalysisDone = [
  AnalysisTaskStatus.done,
  AnalysisTaskStatus.warning,
  AnalysisTaskStatus.error,
];

export const AnalysisStatusRadiusMap = new Map<
  AnalysisTaskStatus,
  AnalysisTaskStatus[]
>([
  [AnalysisTaskStatus.done, [AnalysisTaskStatus.done]],
  [
    AnalysisTaskStatus.warning,
    [AnalysisTaskStatus.done, AnalysisTaskStatus.warning],
  ],
  [
    AnalysisTaskStatus.error,
    [AnalysisTaskStatus.done, AnalysisTaskStatus.error],
  ],
  [AnalysisTaskStatus.failed, [AnalysisTaskStatus.failed]],
  [AnalysisTaskStatus.analyzing, [AnalysisTaskStatus.analyzing]],
  [AnalysisTaskStatus.waiting, [AnalysisTaskStatus.waiting]],
  [AnalysisTaskStatus.submit_failed, [AnalysisTaskStatus.submit_failed]],
  [AnalysisTaskStatus.auto_submit, [AnalysisTaskStatus.auto_submit]],
  [AnalysisTaskStatus.submitted, [AnalysisTaskStatus.submitted]],
  [AnalysisTaskStatus.abort, [AnalysisTaskStatus.abort]],
  [AnalysisTaskStatus.timeout, [AnalysisTaskStatus.timeout]],
]);

export const AnalysisStatusColorMap = new Map<AnalysisTaskStatus, string>([
  [AnalysisTaskStatus.done, newTheme!["green-2"]],
  [AnalysisTaskStatus.warning, newTheme!["orange-1"]],
  [AnalysisTaskStatus.error, newTheme!["red-1"]],
  [AnalysisTaskStatus.failed, newTheme!["red-1"]],
  [AnalysisTaskStatus.analyzing, newTheme!["blue-1"]],
  [AnalysisTaskStatus.waiting, newTheme!["blue-1"]],
  [AnalysisTaskStatus.submit_failed, newTheme!["red-1"]],
  [AnalysisTaskStatus.auto_submit, newTheme!["gray-7"]],
  [AnalysisTaskStatus.submitted, newTheme!["gray-7"]],
  [AnalysisTaskStatus.abort, newTheme!["gray-7"]],
  [AnalysisTaskStatus.timeout, newTheme!["orange-1"]],
]);

export const AnalysisStatusFilterMap = new Map<
  AnalysisTaskStatus,
  AnalysisTaskStatus[] | AnalysisTaskStatus
>([
  [
    AnalysisTaskStatus.done,
    [
      AnalysisTaskStatus.done,
      AnalysisTaskStatus.warning,
      AnalysisTaskStatus.error,
    ],
  ],
  [AnalysisTaskStatus.failed, AnalysisTaskStatus.failed],
  [AnalysisTaskStatus.analyzing, AnalysisTaskStatus.analyzing],
  [AnalysisTaskStatus.waiting, AnalysisTaskStatus.waiting],
  [AnalysisTaskStatus.submit_failed, AnalysisTaskStatus.submit_failed],
  [AnalysisTaskStatus.auto_submit, AnalysisTaskStatus.auto_submit],
  [AnalysisTaskStatus.submitted, AnalysisTaskStatus.submitted],
  [AnalysisTaskStatus.abort, AnalysisTaskStatus.abort],
  [AnalysisTaskStatus.timeout, AnalysisTaskStatus.timeout],
]);

export enum RenderType {
  /** 第一次提交 */
  FIRST = 1,
  /** 确认后第二次提交 */
  SECOND,
}
